import makeStyles from '@material-ui/core/styles/makeStyles'
import React from 'react'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'

const useStyles = makeStyles(() => ({
  typo: {
    color: '#155724', // success green
  },
  success: {
    backgroundColor: '#d4edda', // success background
    padding: '1rem',
  },
}))

const Success = ({ children, ...rest }) => {
  const classes = useStyles()

  return (
    <Paper elevation={1} className={classes.success}>
      <Typography className={classes.typo} variant="subtitle2" {...rest}>
        {children}
      </Typography>
    </Paper>
  )
}

export default Success
